export enum WixFormDatahooks {
  Main = 'wix-forms-main',
  PortalContainer = 'wix-forms-portal-container',
}
